(() => {
  'use strict';

  function renderSizeChartTable(el, csv) {
    const rows = csv
      .trim()
      .split('\n')
      .map((r) => r.split(',').map((cell) => cell.trim()));

    if (!rows.length) return;

    const table = document.createElement('table');
    const thead = document.createElement('thead');
    const tbody = document.createElement('tbody');

    rows.forEach((cells, rowIndex) => {
      const tr = document.createElement('tr');
      cells.forEach((cell) => {
        const tag = rowIndex === 0 ? 'th' : 'td';
        const cellEl = document.createElement(tag);
        cellEl.textContent = cell;
        tr.appendChild(cellEl);
      });
      if (rowIndex === 0) {
        thead.appendChild(tr);
      } else {
        tbody.appendChild(tr);
      }
    });

    table.appendChild(thead);
    table.appendChild(tbody);
    
    // Clear any existing content in case of theme editor reloads
    el.innerHTML = '';
    el.appendChild(table);
  }

  function initShippingTables() {
    document.querySelectorAll('.acci-product__shipping-table').forEach((chartEl) => {
      if (chartEl.dataset.initialized) return;
      chartEl.dataset.initialized = 'true';

      const raw = chartEl.dataset.sizeChart;
      if (!raw) return;

      const isUrl = raw.startsWith('http') || raw.startsWith('/cdn/') || raw.startsWith('/files/');
      if (isUrl) {
        const fetchUrl = raw + (raw.includes('?') ? '&' : '?') + 't=' + Date.now();
        fetch(fetchUrl, { cache: 'no-store' })
          .then((r) => r.text())
          .then((csv) => renderSizeChartTable(chartEl, csv))
          .catch(() => {});
      } else {
        renderSizeChartTable(chartEl, raw);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShippingTables);
  } else {
    initShippingTables();
  }

  document.addEventListener('shopify:section:load', initShippingTables);
  document.addEventListener('shopify:block:select', initShippingTables);
  document.addEventListener('shopify:block:deselect', initShippingTables);
})();